// src/utils/fetchContractData.ts
import axios, { AxiosResponse } from 'axios'
import Cookies from 'js-cookie'
import { contractUrl } from './apiUrls'

// 🤓 Holt dir die Verträge
export const fetchContractData = async (contracts: any[]): Promise<any[]> => {
  try {
    const axiosPromises = contracts.map((requestItem: any) => {
      const modifiedRequestItem = {
        ...requestItem,
        externalCustomerNumber: null
      }

      const config = {
        headers: {
          Authorization: `Bearer ${Cookies.get('token')}`
        },
        data: modifiedRequestItem
      }

      return axios
        .post(contractUrl, modifiedRequestItem, config)
        .then((response: AxiosResponse) => response.data)
    })

    const responseData = await Promise.all(axiosPromises)
    return responseData
  } catch (error) {
    console.error('Fehler beim Vertragsdatenziehen:', error)
    throw error // 🧨 Bombe werfen, damit der Aufrufer's auch mitbekommt
  }
}

export const fetchSingleContract = async (contractId: string, orderNumber:string,customerNumber:string, contractType: number) => {
  const config = {
    headers: {
      Authorization: `Bearer ${Cookies.get('token')}`
    }
  }

  const requestBody = {
    InternalContractId: contractId,
    OrderNumber: orderNumber,
    CustomerNumber :customerNumber,
    ContractType: contractType
  }

  const response = await axios.post(contractUrl, requestBody, config)
  
  return response.data
}
